import {
  getIsVenueSupplierAccomodationRooms,
  getSupplierCountry,
  getSupplierCurrencyCode,
  getSupplierPricingCategory,
  getTypeVenueCeremonyReception,
  getTypeVenueDetails,
  getVenuePackages,
  getVenueSupplierDiningCapacity,
} from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { noop } from 'remeda';
import { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import SupplierKeyInfoComp, {
  KeyInfoSections,
} from '@bridebook/web/app-basic/components/supplier/sections/supplier-key-info/supplier-key-info';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { useMemo } from 'react';

const SupplierKeyInfo = () => {
  const diningCapacity = useSelector(getVenueSupplierDiningCapacity);
  const accomodationRooms = useSelector(getIsVenueSupplierAccomodationRooms);
  const venueDetails = useSelector(getTypeVenueDetails);
  const ceremonyReception = useSelector(getTypeVenueCeremonyReception);
  const packages = useSelector(getVenuePackages);
  const supplierPricingCategory = useSelector(getSupplierPricingCategory);
  const currencyCode = useSelector(getSupplierCurrencyCode);
  const supplierCountry = useSelector(getSupplierCountry);
  const hiddenKeySections: KeyInfoSections[] = useMemo(
    () => (supplierCountry === CountryCodes.FR ? ['weddingLicense'] : []),
    [supplierCountry],
  );
  const market = useMarket();

  return (
    <SupplierKeyInfoComp
      accomodationRooms={accomodationRooms}
      ceremonyReception={ceremonyReception}
      diningCapacity={diningCapacity}
      smallIcons={false}
      packages={packages}
      showFeaturesSection={noop}
      showPricingSection={noop}
      currencyCode={currencyCode}
      supplierPricingCategory={supplierPricingCategory}
      venueDetails={venueDetails}
      hideKeyInfoSections={hiddenKeySections}
      market={market}
    />
  );
};

export default SupplierKeyInfo;
